export default "__VITE_ASSET__c16cf5d7__"